import axios from 'axios';
import { API_VERSION_ROOT } from '../../constants/api';
import { getBackOfficeRoute, headers } from './header';
import { ROLE_ADMIN } from '../../constants/roles';

const RentersApiService = {
  getRenters(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/renters`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postAdminRenters(token, data) {
    const second = data.maxTimeBeforeEmbargo * 60;
    // eslint-disable-next-line no-unused-vars
    const {maxTimeBeforeEmbargo, ...newData} = data;
    const postData = { ...newData, max_time_before_embargo : second}
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/renters`, postData, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postAdminRentersPicture(token, renterId, picture, onUploadProgress = null) {
    const data = new FormData();
    data.append('logo', picture);

    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/renters/${renterId}/logo`, data, {
        headers: headers(token),
        onUploadProgress,
      })
      .then((response) => response.data);
  },

  putAdminRenters(token, data) {
   const second = data.maxTimeBeforeEmbargo * 60;
    // eslint-disable-next-line no-unused-vars
    const {maxTimeBeforeEmbargo, ...newData} = data;
    const putData = { ...newData, max_time_before_embargo : second}
    return axios
      .put(`${getBackOfficeRoute(ROLE_ADMIN)}/renters/${data.id}`, putData, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  deleteAdminRenters(token, renterId) {
    return axios
      .delete(`${getBackOfficeRoute(ROLE_ADMIN)}/renters/${renterId}`, {
        headers: headers(token),
      })
      .then(true);
  },

  getWaitingUsers(token, renterId) {
    return axios
      .get(`${getBackOfficeRoute(ROLE_ADMIN)}/renters/${renterId}/waitings`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postWaitingUser(token, renterId, data) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/renters/${renterId}/waitings`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  deleteWaitingUser(token, renterId, email) {
    return axios
      .delete(`${getBackOfficeRoute(ROLE_ADMIN)}/renters/${renterId}/waitings/${email}`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postRenterAdmin(inviteToken, data) {
    return axios
      .post(`${API_VERSION_ROOT}/public/renters/invite/${inviteToken}`, data)
      .then((response) => response.data);
  },
};

export default RentersApiService;



// WEBPACK FOOTER //
// ./src/services/api/RentersApiService.js